import React from "react";
import { Discipline } from "./types";

interface DisciplineCardProps {
  discipline: Discipline;
}

const DisciplineCard: React.FC<DisciplineCardProps> = ({ discipline }) => {
  return (
    <div className="col-12 col-md-6 mb-4" key={discipline.id}>
      <div className="card discipline-card h-100 shadow-sm">
        <div className="card-header bg-white">
          <h6 className="mb-0">{discipline.student_name}</h6>
        </div>
        <div className="card-body">
          <div className="mb-2">
            <small className="text-muted">Taariikhda Dhacdada</small>
            <p className="mb-0">{discipline.date_of_incident}</p>
          </div>
          <div className="mb-2">
            <small className="text-muted">Kiiska</small>
            <p className="mb-0">{discipline.case}</p>
          </div>
          <div className="mb-2">
            <small className="text-muted">Faahfaahin</small>
            <p className="mb-0">{discipline.description}</p>
          </div>
          <div>
            <small className="text-muted">Waxaa Soo Sheegay</small>
            <p className="mb-0">{discipline.reported_by}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisciplineCard;